import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';

const { breakpoints, palette, typography } = lightTheme;

const sliderButtons = {
  color: palette.primary.main,
  backgroundColor: palette.primary['400'],
  position: 'absolute',
  top: '40%',
  transform: 'translateY(-50%)',
  cursor: 'pointer',
  fontSize: '0.75rem',
  fontWeight: '900',
  height: '1.75rem',
  width: '1.75rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%'
};

const dateUnit = {
  height: '7rem',
  width: '100%',
  backgroundColor: palette.grey['50'],
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '0.5rem',
  border: `0.094rem solid ${palette.primary.main}`,
  cursor: 'pointer'
};

const centerDiv = {
  display: 'flex',
  mx: 'auto'
};

const styles: Record<string, SxProps> = {
  datePickerBox: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',

    '.alice-carousel__next-btn-item': {
      ...sliderButtons,
      right: '-0.3rem'
    },
    '.alice-carousel__prev-btn-item': {
      ...sliderButtons,
      left: '-0.4rem'
    }
  },

  dateBoxWrapper: {
    padding: '0.25rem',
    minWidth: '6.67rem',
    width: '100%',
    float: 'right'
  },

  nextBtn: {
    ...sliderButtons,
    right: '-0.3rem'
  },

  prevBtn: {
    ...sliderButtons,
    left: '-0.4rem'
  },

  datePickerInternalBox: {
    ...centerDiv
  },

  dateCalender: {
    maxWidth: '20rem',
    minWidth: '20rem',
    position: 'relative'
  },

  dayText: {
    color: palette.grey.main,
    textTransform: 'uppercase'
  },

  dateText: {
    color: palette.grey.main,
    my: '0.5rem'
  },

  monthText: {
    color: palette.grey.main,
    textTransform: 'uppercase'
  },

  dateBox: {
    ...dateUnit
  },

  dateBoxDisabled: {
    ...dateUnit,
    border: `0.094rem solid ${palette.primary[200]}`,
    pointerEvents: 'none',
    opacity: '0.5'
  },

  selectedBox: {
    ...dateUnit,
    backgroundColor: palette.primary.light,
    '.MuiTypography-root': {
      color: palette.grey['50']
    }
  },

  timeBox: {
    ...centerDiv,
    justifyContent: 'center',
    gap: '1rem',
    width: '100%',
    div: {
      width: '100%'
    }
  },
  errorChip: {
    borderColor: `${palette.bloodRed[100]}`
  },
  timeButton: {
    [breakpoints.down('md')]: {
      ...typography.body2
    },
    [breakpoints.up('md')]: {
      ...typography.body1
    }
  }
};

export default styles;
